"use client"

import Link from "next/link"
import { useActionState, useState } from "react"
import { ajouterAuPanier } from "@/app/actions/panier"
import type { Product } from "@/lib/types"
import { FormError, SubmitButton } from "./form"

export function AddToCart({ product, preview = false }: { product: Product; preview?: boolean }) {
  const [state, action] = useActionState(ajouterAuPanier, undefined)
  const p = product.personnalisation
  const [text, setText] = useState("")
  const maxQty = product.stock.managed ? Math.min(product.stock.available, 10) : 10
  const multiple = product.kind === "serie" || product.kind === "personnalisable"

  if (!product.purchasable && !preview) return null

  return (
    <form action={action} className="grid gap-4">
      <input type="hidden" name="variant_id" value={product.variant_id ?? ""} />
      {p && (
        <div>
          <label htmlFor="perso" className="etiquette">
            {p.label}
          </label>
          {p.mode === "choix" ? (
            <select id="perso" name="personnalisation" required className="champ" defaultValue="">
              <option value="" disabled>
                Choisir…
              </option>
              {(p.options ?? []).map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </select>
          ) : (
            <>
              <input
                id="perso"
                name="personnalisation"
                required
                maxLength={p.max_length ?? 30}
                value={text}
                onChange={(e) => setText(e.target.value)}
                className="champ"
                autoComplete="off"
              />
              <p className="aide">
                {p.aide ? `${p.aide} ` : ""}
                {text.length}/{p.max_length ?? 30} caractères. Vérifiez l’orthographe : le texte sera peint tel quel.
              </p>
            </>
          )}
        </div>
      )}
      {multiple && maxQty > 1 && (
        <div className="max-w-[9rem]">
          <label htmlFor="qte" className="etiquette">
            Quantité
          </label>
          <select id="qte" name="quantity" className="champ" defaultValue="1">
            {Array.from({ length: maxQty }, (_, i) => i + 1).map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      )}
      <SubmitButton className="bouton w-full sm:w-auto" pending="Ajout…" disabled={preview}>
        Ajouter au panier
      </SubmitButton>
      {preview && <p className="aide">Aperçu : l’ajout au panier est désactivé.</p>}
      <FormError state={state} />
      {state?.ok && (
        <Link href="/panier" className="bouton bouton-clair w-full sm:w-auto">
          Voir le panier
        </Link>
      )}
    </form>
  )
}
